module.exports = __webpack_public_path__ + "static/meadows-detail1-a773c686a90c218d2e91e2240c8e6fe0.jpg";